import { render } from "./ResultCannotContinue.vue?vue&type=template&id=ca259dc4&ts=true"
import script from "./ResultCannotContinue.vue?vue&type=script&lang=ts"
export * from "./ResultCannotContinue.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__